module.exports = __webpack_public_path__ + "img/263.52132269.png";